import { Text } from '@chakra-ui/react';
import React from 'react';

interface WelcomeTextProps {
  children: React.ReactNode;
  fadeDelay?: number;
  size?: 'sm' | 'md';
}

export const WelcomeText: React.FC<WelcomeTextProps> = ({
  children,
  fadeDelay = 0,
  size = 'md',
}) => {
  const fadeInAnimation = {
    '@keyframes fadeIn': {
      from: {
        opacity: 0,
        transform: 'translateY(10px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    animation: `fadeIn 0.5s ease-out ${fadeDelay}s both`,
  };

  const fontSize = {
    sm: { base: 'sm', md: 'md' },
    md: { base: 'md', md: 'lg' },
  };

  return (
    <Text
      fontSize={fontSize[size]}
      color="gray.900"
      textAlign="center"
      css={fadeDelay > 0 ? fadeInAnimation : undefined}
    >
      {children}
    </Text>
  );
};
